export enum CummulativeDeductionConfig {
  Fixed,
  Variable
}
